<template>
  <div class="app-step-two">
    <div class="app-step-two__left">
      <el-form ref="formTwo" label-width="90px" :model="formTwo">
        <el-form-item
          label="品牌名称"
          prop="brandNames"
          :rules="[{ required: true, message: '请输入品牌名称，没有请填“无”', trigger: 'blur' }]">
          <el-input type="textarea" v-model="formTwo.brandNames" size="small" placeholder="请输入品牌名称，多个名称，请用英文“,”隔开"></el-input>
        </el-form-item>
        <el-form-item
          label="竞品名称"
          prop="brandNames"
          :rules="[{ required: true, message: '请输入竞品名称，没有请填“无”', trigger: 'blur' }]">
          <el-input type="textarea" v-model="formTwo.conpetitives" size="small" placeholder="请输入竞品名称，多个名称，请用英文“,”隔开"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="app-step-two__right">
      <div class="app-step-two__example">
        <h5 class="app-step-two__example__title">参考示例</h5>
        <div class="app-step-two__example__content">
          <img src="@/assets/example-02.jpg" alt="示例">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppStep',
  props: {
    brandNames: {
      type: String,
      default: ''
    },
    conpetitives: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      formTwo: {
        brandNames: this.brandNames,
        conpetitives: this.conpetitives
      }
    }
  },

  created () {
    this.$on('validate', function () {
      this.submitForm((error, data) => {
        if (!error) {
          this.$emit('pass', data)
        }
      })
    })
  },

  methods: {
    submitForm (cb) {
      this.$refs.formTwo.validate((valid) => {
        if (valid) {
          cb(null, this.formTwo)
        } else {
          cb(new Error('validate error'), {})
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
.app-step-two {
  display: flex;

  .el-form-item.is-required .el-form-item__label:before {
    font-family: sans-serif;
  }

  &__left,
  &__right {
    flex: 1;
  }

  &__left {
    padding-right: 30px;
    border-right: 1px solid $border-color;
  }

  &__right {
    padding-left: 30px;
  }

  &__example {
    padding: 15px 0;

    &__title {
      margin-top: 0;
      margin-bottom: 15px;
      color: #666;
    }

    &__content {
      width: 100%;
      padding: 10px;
      border: 1px dashed rgb(170, 206, 252);
      border-radius: 4px;
      background-color: rgb(218, 241, 255);

      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
